import react , {useEffect , useState} from "react";
import {
    useParams,
    Link
} from "react-router-dom";
import UpdateComp from "./update";
function Profile(){
    const [object,setobject] = useState({});
    const [url,seturl] = useState("");
    const [pos,setpos] = useState([]);
    
    
    let {id}=useParams();
    const recieve= async (id)=>{
        const response = await fetch("https://lit-fjord-67974.herokuapp.com/friends/"+id);
        try {
            const recieved = await response.json();
            console.log(recieved)
            return recieved
        }catch(err){
            console.log(err)
        }
    }
    const updateee= async ()=>{
        const response = await fetch("https://lit-fjord-67974.herokuapp.com/update/"+id,{
            method:"PATCH",
            credentials:"include",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify(object)
        });
        try {
            const recieved = await response.json();
            return recieved
        }catch(err){
            console.log(err)
        }
    }
    function change(event){
        const {name, value}=event.target;
       setobject((prev)=>{
           return({
               ...prev,
               [name]:value
           })
       })
    }
     
    function submit(){
        // Axios.post("https://lit-fjord-67974.herokuapp.com/stats",formdata,config);
        // update({
        // Username:doc.Username,
        // Hash:doc.Password,
        // Gender:doc.Gender,
        // DateOfBirth:doc.DateOfBirth,
        // KnownAs:doc.KnownAs,
        // Introduction:doc.Introduction,
        // Interests:doc.Interests,
        // City:doc.City,
        // Country:doc.Country    
        // }).then((res)=>{
            
        // })
        updateee().then(()=>{
            recieve(id).then((doc)=>{
                setobject(doc);
                seturl(`https://lit-fjord-67974.herokuapp.com/${doc.photos[0].url}`);
                setpos(doc.Posts.reverse())     
              });
        })
    
    }

    useEffect(()=>{
        
      recieve(id).then((doc)=>{
          setobject(doc);
          seturl(`https://lit-fjord-67974.herokuapp.com/image/${doc.photos[0].url}`);
          setpos(doc.Posts.reverse())     
        });
      
    },[id]);
    
    return(
        <div>
        
        
        
        
        
         
          { localStorage.getItem("User")===id ?
          <UpdateComp iid={id}/>:
          <div className = "profile">
          <img className="profile-img" src={url}/> 
          <div className="profile-list-container">
          <ul >
            
          <li><strong>Username:</strong> {object.Username}</li>
          <li><strong>Born:</strong>{object.DateOfBirth}</li>
          <li><strong>Nickname:</strong>{object.KnownAs}</li>
          <li><strong>Introducion:</strong></li>
          <li>{object.Introduction}</li>
          <li><strong>Interests:</strong></li>
          <li>{object.Interests}</li>
          <li><strong>City:</strong>{object.City}</li>
          <li><strong>Country:</strong>{object.Country}</li>
          
      </ul>
      </div>
      </div>
        }
        

        
        
        
        <div className="post-container">
        { pos.map((item)=>{
      return(
         <div className="home-item2" key={object.id}>
           <div className="img-card2">
           <img width="100%" height="100%" src={url} />
          <p><Link className="Link" to = {`/profile/${object._id}`}> {object.Username}</Link></p>
          </div>
           <p>{item}</p>
         </div>
      )
       })}
         </div>


        </div>)
}

export default Profile